import { LuArrowUp } from "react-icons/lu";
import { useLang } from "../i18n";
import { footerContent, navLinks } from "../data/content";
import { useDemoModal } from "../context/DemoModalContext";
import "./Footer.css";

export default function Footer() {
  const { t } = useLang();
  const { open: openDemoModal } = useDemoModal();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <div className="site-footer-brand">
          <a href="#hero" className="footer-logo" aria-label="Nrativ AB">
            <img src="/img/nrativ.png" alt="Nrativ — Data Analytics" />
          </a>
          <p>{t(footerContent.tagline)}</p>
        </div>

        <nav className="site-footer-nav" aria-label="Footer">
          <ul>
            {navLinks
              .filter((l) => l.id !== "hero")
              .map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`}>{t(l.label)}</a>
                </li>
              ))}
          </ul>
        </nav>

        <div className="site-footer-side">
          <button
            type="button"
            className="btn btn-outline footer-cta"
            onClick={openDemoModal}
          >
            {t({ sv: "Boka en demo", en: "Book a demo" })}
          </button>
          <a href="#hero" className="back-to-top" aria-label="Tillbaka till toppen">
            <LuArrowUp size={16} aria-hidden />
          </a>
        </div>
      </div>

      <div className="container site-footer-legal">
        <span>
          © {year} NRATIV AB. {t(footerContent.rights)}
        </span>
        <span>{t(footerContent.location)}</span>
      </div>
    </footer>
  );
}
